var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers.map(function (item) { return (Object.assign({}, item, {text: _vm.$t(item.text)})); }),"items":_vm.data,"loading":_vm.loading},scopedSlots:_vm._u([{key:"item.countryTaxableTax",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.countryTaxableTax)+"% ")]}},{key:"item.netCountry",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatNumber(item.netCountry))+" ")]}},{key:"item.grossCountry",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatNumber(item.grossCountry))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }